export default "__VITE_ASSET__Ca$gPdL2__"